module.exports = __webpack_public_path__ + "img/SKLB-Registros.bc98fb28.png";